import * as React from 'react';
import * as style from './swiper.module.scss';

const DescriptionSwiper = ({ selectedSlideIndex, selectSlide, data }) => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        spaceBetween: 70,
        direction: 'vertical',
        centeredSlides: true,
        grabCursor: true,
        initialSlide: selectedSlideIndex,
        navigation: {
          nextEl: '.slider__next',
          prevEl: '.slider__prev'
        },
        autoplay: {
          delay: 1000,
          pauseOnMouseEnter: true,
          disableOnInteraction: true,
          initialSlide: selectedSlideIndex,
        },
        watchSlidesProgress: false,
        speed: 1500,
        autoHeight: true
      });
      swiperEl.current.initialize();
    }
    swiperEl.current?.addEventListener('activeindexchange', () => {
      const newIndex = swiperEl.current?.swiper.activeIndex;
      if (newIndex) {
        selectSlide(newIndex);
      }
    });
    if (swiperEl.current?.swiper.activeIndex !== selectedSlideIndex) {
      swiperEl.current?.swiper.slideTo(selectedSlideIndex);
    }
  }, [selectedSlideIndex, selectSlide]);

  return (
    <>
      <swiper-container ref={swiperEl} class={style.descriptionSwiper} init="false">
        {data.map((elem, index) => (
          <swiper-slide key={index}>
            <div className={style.descriptionContainer}>
              <div className={style.descriptionSlide}>
                <div className={style.descriptionWrapper}>
                  <p className={style.descriptionText}>{elem.description}</p>
                  <p className={style.descriptionNote}>{elem.descriptionNote}</p>
                </div>
              </div>
            </div>
          </swiper-slide>
        ))}
      </swiper-container>
    </>
  );
};
export default DescriptionSwiper;
